/*
 * File Import Drag/Drop
 */

.root {
  display: flex;
  justify-content: center;
  align-items: center;

  margin: 40px 30px;
  font-size: 17pt;

  /* TODO: should this be a global class name? */
  &.dragging {
    background-color: lightyellow;
  }

  /* https://stackoverflow.com/a/42835826/1999152 */
  /* TODO: For now use hover as the hack */
  @media (hover) {
    border: 3px dashed darkgray;

    .or-drag::after {
      content: ' or drag it here';
    }
  }

  .drop_content {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  .file_picker {
    padding-top: 10px;
  }
  #file_input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;

    /* https://css-tricks.com/copy-the-browsers-native-focus-styles/ */
    &:focus + label {
      outline: 5px auto Highlight;
      outline: 5px auto -webkit-focus-ring-color;
    }
  }

  .file_input_label {
    font-weight: bold;
    cursor: pointer;
    padding: 4px;
    text-decoration: underline;

    &:hover {
      color: gray;
    }
    +span {
      margin-left: -5px;
      /* text-decoration: underline; */
    }
  }

  .ebird_download {
    font-size: 50px;
  }
}
